module.exports = __webpack_public_path__ + "img/img_hope04.3eb6b7b0.jpg";